import React from 'react'
import {FaqPanel} from './FaqModal'
import Logo from 'images/pop-logo.svg'

export default function FaqPage() {
  return (
    <div className="pb-10">
      <img
        src={Logo}
        className="object-center object-contain h-12 mx-auto mb-12"
        alt="Integria Logo"
      />
      <FaqPanel />
    </div>
  )
}